module.exports = __webpack_public_path__ + "media/images/pic/courses/pakiet-startowy-93800934e028f4b3733ee0100915fa9b.png";